import { render, staticRenderFns } from "./HelpVideo.vue?vue&type=template&id=da3c4006&scoped=true"
import script from "./HelpVideo.vue?vue&type=script&lang=js"
export * from "./HelpVideo.vue?vue&type=script&lang=js"
import style0 from "./HelpVideo.vue?vue&type=style&index=0&id=da3c4006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3c4006",
  null
  
)

export default component.exports